module.exports = __webpack_public_path__ + "img/scales.f2c939d9.svg";